<template>
    <slot :selectedPack="selectedPack" :close="close" :openPacks="openPacks" :bookNow="bookNow"></slot>
</template>

<script>
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';

import eventBus from './utils/event-bus';

export default defineComponent({
    name: 'PricesPopup',
    setup(props) {
        const dialog = ref(null);
        const selectedPack = ref(null);

        const handlePackChange = pack => {
            selectedPack.value = pack;
        }

        const open = () => {
            eventBus.emit('packsPopup:close');
            dialog.value.showModal();
        }

        const close = () => {
            dialog.value.close();
        }

        const openPacks = () => {
            eventBus.emit('packsPopup:open');
        }

        const bookNow = () => {
            console.log('prices popup book clicked');
            eventBus.emit('bookNow');
        }

        onMounted(() => {
            dialog.value = document.querySelector('#series-price-popup');

            eventBus.on('packChanged', handlePackChange);
            eventBus.on('pricesPopup:open', open);
            eventBus.on('pricesPopup:close', close);
        });

        onUnmounted(() => {
            eventBus.off('packChanged', handlePackChange);
            eventBus.off('pricesPopup:open', open);
            eventBus.off('pricesPopup:close', close);
        });

        return {
            selectedPack,
            close,
            openPacks,
            bookNow,
        }
    },
});
</script>
